module.exports = __webpack_public_path__ + "static/media/30_TOP_FRENTE_UNICA_COM_BOJO_ESTAMPADO_01.8027e693.jpg";